<template>
  <div>
    <div @click="visible = true">
      <slot />
    </div>

    <a-modal
      title="选择项目"
      :visible="visible"
      @cancel="cancel"
      :footer="null"
      width="800px"
    >
      <a-input-search
        style="margin-bottom: 16px"
        placeholder="请输入项目名称搜索"
        enter-button
        @search="onSearch"
      ></a-input-search>

      <a-table
        :indentSize="0"
        bordered
        :data-source="list"
        :loading="loading"
        @change="onChange"
        :pagination="{
          total,
          current,
          pageSize,
          showTotal: (total) => `共 ${total} 条记录`,
        }"
        :rowClassName="() => 'clickable'"
        :customRow="
          (record) => {
            return {
              on: {
                click: () => {
                  onTableRowClick(record);
                },
              },
            };
          }
        "
        :scroll="{ x: 500 }"
        style="table-layout: fixed"
      >
        <a-table-column title="备案编号" data-index="filingNum" width="180px" />
        <a-table-column title="项目名称" data-index="projectName" minWidth="240px" />
        <a-table-column title="业主单位" data-index="customerName" width="240px" />
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import {getProjectFilingList} from "@/api/market/projectFiling";
export default {
  data() {
    return {
      visible: false,

      searchValue: "",

      loading: false,
      current: 1,
      pageSize: 10,
      list: [],
      total: 0,
    };
  },

  watch: {
    visible(newValue) {
      if (newValue) {
        if (this.list.length === 0) {
          this.getList();
        }
      }
    },
  },

  methods: {
    getList() {
      this.loading = true;
      getProjectFilingList({
        pageNum: this.current,
        pageSize: this.pageSize,
        projectName: this.searchValue,
        status: "End",
      })
        .then((res) => {
          if (res && Array.isArray(res.list)) {
            this.list = Object.freeze(res.list);
            this.total = res.totalSize || 0;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onChange(pagination) {
      this.current = pagination.current;
      this.getList();
    },

    onSearch(value) {
      this.searchValue = value;
      this.current = 1;
      this.getList();
    },

    onTableRowClick(record) {
      this.$emit("change", record);
      this.visible = false;
    },

    cancel() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
// 表格单元格文本溢出自动省略
::v-deep .ant-table-thead > tr > th,
::v-deep .ant-table-tbody > tr > td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
